import React, { useEffect, useState } from "react";
import NoSearchitems from "../../components/NoSearchitems";
import Modal from "react-modal";
import { RxCross2 } from "react-icons/rx";
import axios from "axios";
import ImageLoading from "../../components/ImageLoading";
const customStyles = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0,80%)",
    zIndex: "100",
    overflow: "scroll",
  },
};

function DematTable({ id, filter, setUserNumber }) {
  const lender_id = 6;
  const [openDetails, setOpenDetails] = useState(false);
  const [imageLoading, setImageLoading] = useState(false);
  const [orderItems, setOrderItems] = useState([]);

  function truncateText(text, maxLength) {
    if (text.length > maxLength) {
      return text.substring(0, maxLength - 3) + "...";
    } else {
      return text;
    }
  }

  function formatToIndianRupees(num) {
    // Convert the number to a string
    num = parseInt(num);
    if (num === null || num === undefined) return "--";
    return num.toLocaleString("en-IN", {
      style: "currency",
      currency: "INR",
    });
  }

  const fetchUsersView = async (controller) => {
    setImageLoading(true);
    const token = localStorage.getItem("token");
    const options = {
      method: "GET",
      headers: { Authorization: token },
      signal: controller.signal,
    };
    try {
      const res = await axios.request(
        `${process.env.REACT_APP_URL}/lender/v1/check_eligibility_users/${id}?holding_type=${filter}`,
        options
      );
      if (res.data) {
        setOrderItems(res?.data?.user_detail);
        setUserNumber(res?.data?.phone);
      }
    } catch (error) {
      console.log(error);
      setOrderItems([]);
    } finally {
      setImageLoading(false);
    }
  };
  useEffect(() => {
    const controller = new AbortController();
    fetchUsersView(controller);
  }, [filter]);
  return (
    <>
      <div className=" rounded border border-[#e2ecff] mt-4  overflow-auto">
        <table className="w-full min-w-[1130px] box-border  flex flex-col mt-4 rounded ">
          <thead className="text-xs font-semibold">
            <tr
              className={`w-full flex items-center ${
                lender_id === 6 && "justify-between"
              }   h-[60px]`}
            >
              <th className={` pl-6 pt-1 text-left  w-[20%] pr-4`}>
                Constituents
              </th>

              <th className="text-left  w-[9%]">Repository</th>
              <th className={`text-left w-[12%] `}> Tentative LTV(%)</th>
              <th className={`text-left w-[8%] mr-[2%]  `}>Fetched Unit</th>

              <th className={`text-left w-[10%] `}>
                Current Fetched Unit Price
              </th>
              <th className={`text-left w-[13%] ml-[2%] mr-[1%]`}>
                Fetched Unit value
              </th>
              {/* {filter === "unapprovedHoldings" && (
                <th className={`text-left w-[10%] mr-2 pl-[1%]`}>
                  Unapproval Reason
                </th>
              )} */}
              {lender_id !== 6 && (
                <>
                  {" "}
                  <th className={`pl-[1%]  text-left w-[11%] `}>
                    Corporate Action
                  </th>
                  <th className={`text-right w-[12%] pr-6`}>Details</th>
                </>
              )}
            </tr>
          </thead>

          <tbody
            className={` max-h-[calc(100vh-325px)] overflow-auto  ${
              orderItems?.length === 0 ? " " : ""
            }`}
          >
            {orderItems?.length === 0 && !imageLoading && (
              <>
                <div className=" h-[250px]">
                  <NoSearchitems />
                </div>
              </>
            )}
            {imageLoading && (
              <>
                <div className=" h-[250px] w-full flex justify-center items-center">
                  <ImageLoading />
                </div>
              </>
            )}
            {!imageLoading &&
              orderItems?.map((data, index) => (
                <tr
                  className={`text-xs font-medium w-full flex items-center ${
                    lender_id === 6 && "justify-between"
                  }  h-[60px] ${index % 2 === 0 ? "bg-[#f8f8f8]" : "bg-white"}`}
                >
                  <td
                    className={`text-left pl-6 w-[20%] pt-3 pb-2 pr-4`}
                    title={data?.scheme_name}
                  >
                    {truncateText(data?.scheme_name, 50)}
                  </td>
                  <td className="text-left  w-[9%]">
                    {" "}
                    {`${data?.repository || "NA"}`}
                  </td>
                  <td className={`text-left w-[12%] `}>{data?.ltv || "---"}</td>
                  <td className={`text-left w-[10%]  `}>
                    {data?.available_units || "---"}
                  </td>

                  <td className={`text-left w-[10%] `}>
                    {data?.current_value
                      ? formatToIndianRupees(data?.current_value)
                      : "--"}
                    <span
                      className={`ml-1 ${
                        data.current_fetched_unit_price_percent < 0
                          ? "text-[#d30000] "
                          : "text-[#0ba300]"
                      }`}
                    >
                      {data.current_fetched_unit_price_percent !== null
                        ? `(${data.current_fetched_unit_price_percent}%)`
                        : ""}
                    </span>
                  </td>
                  <td className={`text-left w-[13%] ml-[2%] mr-[1%]`}>
                    {data?.fetched_current_total
                      ? formatToIndianRupees(data?.fetched_current_total)
                      : "--"}
                    <span
                      className={`ml-1 ${
                        data.fetched_current_total_percent < 0
                          ? "text-[#d30000] "
                          : "text-[#0ba300]"
                      }`}
                    >
                      {data?.fetched_current_total_percent !== null
                        ? `(${data?.fetched_current_total_percent}%)`
                        : ""}
                    </span>
                  </td>
                  {/* {filter === "unapprovedHoldings" && (
                  <td className={`text-left w-[10%] mr-2 pl-[1%]`}>
                    <p className=" text-[#004682] bg-[#e9f5ff] rounded-[2px] w-fit px-1 py-[2px] ">
                      {data.reason || "---"}
                    </p>
                  </td>
                )} */}
                  {lender_id !== 6 && (
                    <>
                      <td className={`pl-[1%] text-left w-[11%] `}>
                        {data.corporate_action || "--"}
                      </td>
                      <td className={`text-right w-[12%] pr-6`}>
                        {data.corporate_action ? (
                          <button
                            onClick={() => {
                              setOpenDetails(true);
                            }}
                            className="text-[#0070d2]"
                          >
                            See Details
                          </button>
                        ) : (
                          "--"
                        )}
                      </td>
                    </>
                  )}
                </tr>
              ))}
            {/* <tr
              className={`text-xs font-medium w-full flex items-center  h-[60px] bg-[#e6ebed]`}
            >
              <th className={` pl-6 pt-1 text-left  w-[18%] pr-6`}></th>

              <th className="text-left  w-[9%]"></th>
              <th className={`text-left w-[12%] `}> </th>
              <th className={`text-left w-[8%] mr-[2%]  `}></th>

              <th className={`text-left w-[10%] `}></th>
              <th className={`text-left w-[13%] ml-[2%] mr-[1%]`}>
                {true ? formatToIndianRupees(192000) : "--"}
                <span
                  className={`ml-1 ${
                    false ? "text-[#d30000] " : "text-[#0ba300]"
                  }`}
                >
                  {true ? `(${8}%)` : ""}
                </span>
              </th>
              {filter === "unapprovedHoldings" && (
                <th className={`text-left w-[10%] mr-2 pl-[1%]`}></th>
              )}
              <th className={`pl-[1%]  text-left w-[11%] `}></th>
              <th className={`text-right w-[12%] pr-6`}></th>
            </tr> */}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default DematTable;
